import { render, staticRenderFns } from "./TestimonialsSegment.vue?vue&type=template&id=6ec98461&"
import script from "./TestimonialsSegment.vue?vue&type=script&lang=js&"
export * from "./TestimonialsSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports